module.exports = __webpack_public_path__ + "static/img/3_1_2.70588c34.jpg";